import utils = egr.wcf.utils;

function btoaReplaceCallback(match: string, p1: string): string {
    // tslint:disable-next-line:no-any
    return String.fromCharCode(('0x' + p1) as any);
}

export function b64EncodeUnicode(value: string): string {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(encodeURIComponent(value).replace(/%([0-9A-F]{2})/g, btoaReplaceCallback));
}

function atobReplaceCallback(c: string): string {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
}

export function b64DecodeUnicode(value: string): string {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(value).split('').map(atobReplaceCallback).join(''));
}

export function dataUrlToBase64String(data: string): string {
    const term: string = ';base64,';
    const termLength: number = term.length;

    const index: number = data.indexOf(term);
    if (index === -1) {
        throw new Error('unsupported data url');
    }

    return data.substr(index + termLength);
}

export function uint8ArrayToString(data: Uint8Array): string {
    let value: string = '';

    // Note: a loop is used instead of `String.fromCharCode.apply` to
    // avoid `Maximum call stack size` exceptions
    for (let i: number = 0, l: number = data.length; i < l; i++) {
        value += String.fromCharCode(data[i]);
    }

    return value;
}

export function base64ToUint8Array(data: string): Uint8Array {
    if (utils.string.isNullOrEmpty(data)) {
        return new Uint8Array(0);
    }

    const byteStr: string = atob(data);
    const len: number = byteStr.length;
    const bytes: Uint8Array = new Uint8Array(len);
    for (let i: number = 0; i < len; i++) {
        bytes[i] = byteStr.charCodeAt(i);
    }

    return bytes;
}

export function base64ToBlob(data: string, contentType: string = '', sliceSize: number = 512): Blob {
    const byteCharacters: string = atob(data);
    const byteArrays: Array<Uint8Array> = [];

    for (let offset: number = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice: string = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers: Array<number> = new Array(slice.length);
        for (let i: number = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray: Uint8Array = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, {type: contentType});
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/app-api/Converter.ts